import { ResourceHeaders } from '..'
import {
  AlertsHeader,
  IdHeader,
  PhotoHeader,
  PriceHeader,
  TextHeader,
  VehicleHeader,
  VehicleStatusHeader,
} from '../../headers'
import { Helpers } from '../../helpers'
import { extendsObj } from '@/utils/data'
import { TableCellHeader } from '@/components/dataTables/cell'

export const headers: ResourceHeaders = [
  extendsObj<TableCellHeader>({
    text: 'Nº',
    value: '@',
    width: 70,
  }, IdHeader),
  { ...PhotoHeader, text: 'Foto', value: '@' },
  { ...AlertsHeader, text: 'Alerta', value: 'stockPriceAlert', sortable: true },
  extendsObj<TableCellHeader>({
    text: 'Stock',
    value: '@',
    options: {
      path: 'auto.name',
      trigger: item => Helpers.linkedModel({ constructor: { name: 'StockPublish' }, ...item }),
    },
  }, VehicleHeader),
  { ...VehicleStatusHeader, text: 'Estado de stock', value: 'stockStatus' },
  { ...TextHeader, text: 'Llave', value: 'keyIdentifier.keyId', width: 120 },
  { ...TextHeader, text: 'Característica', value: 'auto.characteristic' },
  { ...TextHeader, text: 'Kilometraje', value: 'kms' },
  { ...TextHeader, text: 'Dueños', value: 'owners' },
  { ...PriceHeader, text: 'Pie 20%', value: 'pieTwenty' },
  { ...PriceHeader, text: 'Pie 40%', value: 'pieForty' },
]

export default function (): ResourceHeaders {
  return headers
}
